import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import _toConsumableArray from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

var AppSimpleSearchSelector = /*#__PURE__*/function (_Vue) {
  _inherits(AppSimpleSearchSelector, _Vue);

  var _super = _createSuper(AppSimpleSearchSelector);

  function AppSimpleSearchSelector() {
    var _this;

    _classCallCheck(this, AppSimpleSearchSelector);

    _this = _super.apply(this, arguments);
    _this.model = {
      id: undefined,
      label: '全部'
    };
    _this.viewModel = '';
    _this.loading = false;
    _this.showPWD = false;
    _this.delay = null;
    _this.listPosConf = {
      top: 0,
      left: 0,
      width: 0
    };
    _this.showList = false;
    _this.rules = {
      required: function required(value) {
        return !!value || 'Required.';
      },
      text: function text() {
        return true;
      }
    };
    _this.selectedIdx = -1;
    _this.ifClick = false;
    return _this;
  }

  _createClass(AppSimpleSearchSelector, [{
    key: "mounted",
    value: function mounted() {
      if (this.value && !this.$R.isEmpty(this.value)) {
        this.onValueChanged(this.value);
      }

      this.onResize();
    }
  }, {
    key: "onResize",
    value: function onResize() {
      var inputDom = this.$refs.searchOrInput;
      var input = inputDom.getBoundingClientRect();
      this.listPosConf.width = input.width;
      var optionsHeight = Math.min((this.options.length + 1) * 48 + 16, 350);

      if (this.options.length > 0 && input.y > window.innerHeight - optionsHeight) {
        this.listPosConf.top = optionsHeight > 350 ? window.innerHeight - 350 : window.innerHeight - optionsHeight;
        this.listPosConf.left = 2 * input.width + input.x > window.innerWidth ? input.x - input.width - 10 : input.x + input.width + 10;
      } else {
        this.listPosConf.top = input.y + (this.dense ? 30 : 36);
        this.listPosConf.left = input.x;
      }
    }
  }, {
    key: "onItemsChanged",
    value: function onItemsChanged() {
      this.onResize();
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val) {
      this.model = val || {
        id: undefined,
        label: ''
      };
      this.viewModel = val ? val.label : '';
    }
  }, {
    key: "onSearchChanged",
    value: function onSearchChanged(val) {
      var _this2 = this;

      if (this.items.length === 2 && this.items[1].label === val) {
        return;
      }

      this.delay = setTimeout(function () {
        _this2.searchHandler();
      }, 500);
    }
  }, {
    key: "focusHandler",
    value: function focusHandler() {
      this.onResize();
      this.showList = true;
    }
  }, {
    key: "blurHandler",
    value: function blurHandler() {
      var _this3 = this;

      if (this.items.length === 0 || !this.viewModel) {
        this.model = {
          id: undefined,
          label: ''
        };
        this.viewModel = '';
      }

      setTimeout(function () {
        var viewModel = _this3.viewModel;
        _this3.showList = false;

        if (_this3.ifClick) {
          _this3.ifClick = false;
          return;
        }

        if (viewModel) {
          var matchItem = _this3.items.find(function (item) {
            return item.label.toLowerCase() === viewModel.toLowerCase();
          });

          if (matchItem) {
            _this3.model = matchItem;
          } else {
            var res = _this3.items.find(function (item) {
              return item.label.toLowerCase().indexOf(viewModel.toLowerCase()) !== -1;
            });

            if (res) {
              _this3.model = res;
              _this3.viewModel = res.label;
            }
          }
        }

        _this3.valueChangedHandler();
      }, 300);
    }
  }, {
    key: "keyDownHandler",
    value: function keyDownHandler(e) {
      var selectedIdx = !isNaN(this.selectedIdx) ? this.selectedIdx : -1;

      switch (e.key) {
        case 'ArrowUp':
          this.selectedIdx = selectedIdx - 1 < 0 ? 0 : selectedIdx - 1;
          break;

        case 'ArrowDown':
          this.selectedIdx = selectedIdx + 1 > this.items.length - 1 ? this.items.length - 1 : selectedIdx + 1;
          break;

        case 'Enter':
          this.selectHandler(selectedIdx);
          break;

        case 'Backspace':
          this.showList = true;
      }
    }
  }, {
    key: "findhHandler",
    value: function findhHandler() {
      return {
        name: this.viewModel,
        type: 'find'
      };
    }
  }, {
    key: "searchHandler",
    value: function searchHandler() {
      return {
        model: this.viewModel,
        take: 20
      };
    }
  }, {
    key: "valueChangedHandler",
    value: function valueChangedHandler() {
      return this.model;
    }
  }, {
    key: "selectHandler",
    value: function selectHandler(idx) {
      if (idx === 0) {
        this.model = {
          id: undefined,
          label: ''
        };
        this.viewModel = '';
      } else {
        var selected = this.items[idx - 1];

        if (selected) {
          this.model = selected;
          this.viewModel = selected.label;
        }

        this.showList = false;
        this.ifClick = true;
      }

      this.valueChangedHandler();
    }
  }, {
    key: "clearModel",
    value: function clearModel() {
      if (this.disabled) {
        return;
      }

      this.selectHandler(0);
    }
  }, {
    key: "options",
    get: function get() {
      return [{
        id: undefined,
        label: '全部'
      }].concat(_toConsumableArray(this.items));
    }
  }]);

  return AppSimpleSearchSelector;
}(Vue);

__decorate([Prop({
  type: Object
})], AppSimpleSearchSelector.prototype, "value", void 0);

__decorate([Prop(String)], AppSimpleSearchSelector.prototype, "label", void 0);

__decorate([Prop({
  type: String
})], AppSimpleSearchSelector.prototype, "placeholder", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSearchSelector.prototype, "required", void 0);

__decorate([Prop({
  type: [Number, String],
  default: '289'
})], AppSimpleSearchSelector.prototype, "width", void 0);

__decorate([Prop({
  type: [Number, String],
  default: 36
})], AppSimpleSearchSelector.prototype, "height", void 0);

__decorate([Prop({
  type: String
})], AppSimpleSearchSelector.prototype, "confirm", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSearchSelector.prototype, "autofocus", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSearchSelector.prototype, "disabled", void 0);

__decorate([Prop({
  type: Array
})], AppSimpleSearchSelector.prototype, "items", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSearchSelector.prototype, "showSearchBtn", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], AppSimpleSearchSelector.prototype, "className", void 0);

__decorate([Prop({
  type: String,
  default: ''
})], AppSimpleSearchSelector.prototype, "inlineLabel", void 0);

__decorate([Prop({
  type: Boolean,
  default: false
})], AppSimpleSearchSelector.prototype, "dense", void 0);

__decorate([Watch('items', {
  deep: true
})], AppSimpleSearchSelector.prototype, "onItemsChanged", null);

__decorate([Watch('value')], AppSimpleSearchSelector.prototype, "onValueChanged", null);

__decorate([Watch('viewModel')], AppSimpleSearchSelector.prototype, "onSearchChanged", null);

__decorate([Emit('find')], AppSimpleSearchSelector.prototype, "findhHandler", null);

__decorate([Emit('query')], AppSimpleSearchSelector.prototype, "searchHandler", null);

__decorate([Emit('input')], AppSimpleSearchSelector.prototype, "valueChangedHandler", null);

__decorate([Emit('selected')], AppSimpleSearchSelector.prototype, "selectHandler", null);

AppSimpleSearchSelector = __decorate([Component], AppSimpleSearchSelector);
export default AppSimpleSearchSelector;